<template>
  <layout>
    <template slot="navbar">
      <navbar :class="{ 'has-shadow': !isStartView }">
        <search-field
          placeholder="Поиск документа..."
          input-class="is-medium"
          v-model="searchText"
        ></search-field>
      </navbar>
    </template>
    <slot v-if="!searchStart"></slot>
    <reestr-doc-search
      v-else
      :project-schema="currentProject.schema"
      :search-text="searchText"
      class="reestr-panel"
    ></reestr-doc-search>
  </layout>
</template>

<script>
import Layout from "./Layout";
import Navbar from "@/components/Navbar.vue";
import SearchField from "@/components/documents/SearchField";
import ReestrDocSearch from "@/components/documents/ReestrDocSearch";
import { mapState } from "vuex";

export default {
  data() {
    return {
      searchText: "",
    };
  },
  components: {
    Layout,
    Navbar,
    SearchField,
    ReestrDocSearch,
  },
  computed: {
    ...mapState(["currentProject"]),
    searchStart() {
      return this.searchText !== "";
    },
    isStartView() {
      return this.$route.name === "gksisogdSections";
    },
  },
  watch: {
    searchText(value) {
      if (value)
        window.history.replaceState(
          history.state,
          "",
          this.$route.path + "?q=" + value
        );
      else window.history.replaceState(history.state, "", this.$route.fullPath);
    },
  },
  created() {
    if (this.$route.query.q) {
      this.searchText = this.$route.query.q;
    }
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../assets/sass/main.scss";

.reestr-panel {
  margin-top: 3.6rem !important;

  @include mobile {
    margin-top: 1rem !important;
  }
}
</style>